import { render, staticRenderFns } from "./serveMsg.vue?vue&type=template&id=0db1d9b0&scoped=true&"
import script from "./serveMsg.vue?vue&type=script&lang=js&"
export * from "./serveMsg.vue?vue&type=script&lang=js&"
import style0 from "./serveMsg.vue?vue&type=style&index=0&id=0db1d9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1d9b0",
  null
  
)

component.options.__file = "serveMsg.vue"
export default component.exports